export default () => ({
  isShown: false,
});
